<template>
    <div>
        <div class="ibox p-4">
            <b-form-group class="my-3">
                <b-form-checkbox size="lg" @change="changeLongServicePolicy" v-model="long_service_status" name="long_service_status" switch value="1" unchecked-value="0">Enable Long Service Leave</b-form-checkbox>
            </b-form-group>

            <div class="clearfix row py-2 mb-3" v-if="long_service_status == 1">
                <div class="col-sm-3 px-3 company-form-box-title">Long Service Leave</div>
                <div class="col-sm-4"></div>
                <div class="col-sm-5 float-right text-right px-0">
                    <!-- AbdullahFixed added mr-5 here  -->
                <b-button v-if="ce" id="show-btn" class="mr-3" @click="addNew">Add Slot</b-button>
                </div>
            </div>

            <!-- Table -->
            <div class="row justify-content-center no-margin" v-if="long_service_status == 1">
                <div class="col-sm-12 px-0">
                    <b-overlay :show="showoverlay_list" rounded="sm">
                        <!-- alpha fix- added class border  -->
                        <table class="table dataTable border">
                            <thead>
                                <tr class="table-head">
                                    <td>Minimum Months</td>
                                    <td>Days Entitled</td>
                                    <td class="text-right" v-if="ce">Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(policy, index) in policies" :key="index">
                                    <td>{{ policy.minimum_required_months }}</td>
                                    <td>{{ policy.days_entitled }}</td>
                                    <td class="position-relative text-right" v-if="ce">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                            style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false"><b-icon
                                                icon="three-dots-vertical"></b-icon></a>

                                                <!-- // AbdullahALC chnaged added this code, removed w-200 from class -->
                                        <div class="dropdown-menu action-dropdown-menu"
                                            aria-labelledby="actionDropdown">
                                            <!-- // AbdullahALC chnaged added this code, removed  class="mr-0"  -->
                                            <b-button-group>

                                                <!-- // AbdullahALC chnaged added this code, removed btn claass added varients  -->
                                                <b-button variant="outline-secondary" title="Edit"
                                                    @click="editPolicy(policy.id, policy.minimum_required_months, policy.days_entitled)">
                                                    <b-icon icon="pencil"></b-icon>Edit
                                                </b-button>

                                                <!-- // AbdullahALC chnaged added this code, here is the original btn code  -->
                                                <!-- <b-button class="mr-3 rounded edit-btn" title="Edit"
                                                    @click="editPolicy(policy.id, policy.minimum_required_months, policy.days_entitled)">
                                                    <b-icon icon="pencil" class="mr-2" aria-hidden="true"></b-icon>Edit
                                                </b-button> -->

                                                <!-- <b-button class="mr-3 rounded edit-btn" title="Delete"
                                                    @click="deletePolicy(policy.id)">
                                                    <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                </b-button> -->
                                            </b-button-group>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="px-3">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{policies.length}} records found.</li>
                            </ul>
                            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>

        <b-modal id="bv-modal-add-longservice-leave" size="xl" scrollable hide-footer :title=" (this.fdata.id == '' ? 'Add' : 'Edit' )+ ' Long Service Leave'">
            <b-form @submit.stop.prevent="savePolicy">
                <b-alert :show="this.fdata.id == ''"><span class="text-danger"><strong>Attention:</strong> Long service leave cannot be deleted. If updates are needed, please make the necessary adjustments.</span></b-alert>
                <b-form-group label="Minimum Required Months" class="required-field" label-for="minimum-required-months"  >
                    <b-form-input id="minimum-required-months" v-model="fdata.minimum_required_months" v-validate="{required: true, numeric: true,min_value:1, max_value:1200}" name="minimum_required_months" :state="validateState('minimum_required_months')" aria-describedby="minimum-required-months-feedback" data-vv-as="Month" ></b-form-input>
                    <b-form-invalid-feedback id="minimum-required-months-feedback"> {{ veeErrors.first('minimum_required_months') }} </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Days Entitled" class="required-field" label-for="days-entitled" >
                    <b-form-input id="days-entitled" v-model="fdata.days_entitled" v-validate="{required:true,numeric:true,min_value:0,max_value:1200}" name="days_entitled" :state="validateState('days_entitled')" aria-describedby="days-entitled-feedback" data-vv-as="Entitled Days"></b-form-input>
                    <b-form-invalid-feedback id="days-entitled-feedback">{{ veeErrors.first('days_entitled') }}</b-form-invalid-feedback>
                </b-form-group>

                <!-- AbdullahALC chnaged the btn design and position -->
                <div class="btn-wrapper text-center pt-5">
                    <b-button type="submit btn-primary" variant="primary" v-if="fdata.id">Update</b-button>
                    <b-button type="submit btn-primary" variant="primary" v-else>Save</b-button>
                </div>

            </b-form>
        </b-modal>

    </div>
</template>

<script>
export default {
    data() {
        return {
            long_service_status: 0,
            policies: [],
            showoverlay_list: false,
            ce: true,
            search:'',
            fdata: {
                id: '',
                minimum_required_months: '',
                days_entitled: '',
            },
            pagination: {currentPage: 1, pages:1},
            length: 20,
            temp_length:20,
            length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
        };
    },
    created: function () {
        this.getPolicies();
        this.getPolicy();
    },
    methods: {
        getPolicy() {
            axios
                .get(this.$api_url + '/longservice-leave/check')
                .then((response) => {
                    this.long_service_status = response.data;
                })
                .catch((err) => {
                    console.error('Error fetching policies:', err);
                });
        },
        getPolicies() {
            this.showoverlay_list = true;
            axios
                .get(this.$api_url + '/longservice-leave/get-company-policies')
                .then((response) => {
                    this.policies = response.data;
                    this.showoverlay_list = false;
                })
                .catch((err) => {
                    console.error('Error fetching policies:', err);
                    this.policies = [];
                    this.showoverlay_list = false;
                });
        },
        changeLongServicePolicy(){
            axios.post(this.$api_url + '/longservice-leave/changepolicy').then((response) => {
                    // this.policies = response.data.policies;
                    this.showoverlay_list = false;
                    this.getPolicies();
                    this.long_service_status = response.data.long_service_status;

                    this.$bvToast.toast(response.data.message, {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });
                }).catch((err) => {
                    console.error('Error fetching policies:', err);
                    this.policies = [];
                    this.showoverlay_list = false;
                });
        },
        addNew() {
            this.fdata = {
                id: '',
                minimum_required_months: '',
                days_entitled: '',
            },
            this.$bvModal.show('bv-modal-add-longservice-leave');
        },
        savePolicy(e) {

            if(this.fdata.id != ''){
                this.updatePolicy(e);
                return;
            }

            this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    e.preventDefault();


            this.showoverlay = true;

            axios.post(this.$api_url + '/longservice-leave/save-policy', this.fdata)
                .then(response => {
                    this.$bvToast.toast(response.data.message || 'Saved successfully.', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });

                    this.$bvModal.hide('bv-modal-add-longservice-leave');
                    this.getPolicies();
                })
                .catch(error => {
                    const message =
                        error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'An unexpected error occurred.';

                    this.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                })
                .finally(() => {
                    this.showoverlay = false;
                });
                });

        },

            validateState:function(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
        editPolicy(id, minimum_required_months, days_entitled) {
            console.log('Edit leave');
            this.fdata.id = id;
            this.fdata.minimum_required_months = minimum_required_months;
            this.fdata.days_entitled = days_entitled;
            this.$bvModal.show('bv-modal-add-longservice-leave');
        },
        updatePolicy(e) {

            this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    e.preventDefault();
            this.showoverlay = true;

            axios.post(this.$api_url + '/longservice-leave/update-policy', this.fdata)
                .then(response => {
                    this.$bvToast.toast(response.data.message || 'Saved successfully.', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });

                    this.$bvModal.hide('bv-modal-add-longservice-leave');
                    this.getPolicies();
                })
                .catch(error => {
                    const message =
                        error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'An unexpected error occurred.';

                    this.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                })
                .finally(() => {
                    this.showoverlay = false;
                });
            });
        },
     /*   deletePolicy(id) {
            this.showoverlay = true;
            let formData = new FormData();
            formData.append('id', id);
            axios.post(this.$api_url + '/longservice-leave/delete-policy', formData)
                .then(function (response) {
                    this.$bvToast.toast('Deleted!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });

                    this.getPolicies();
                }.bind(this))
                .catch(error => {
                    const message =
                        error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'An unexpected error occurred.';

                    this.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                })
                .finally(() => {
                    this.showoverlay = false;
                });
        },
        */
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        }
    },
    computed:
    {
        filteredData()
        {
            let filtered_list = this.policies;
            return filtered_list;
        },
        paginatedData()
        {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
};
</script>

<style scoped>
.table-head {
    font-weight: bold;
}
</style>
